import axios, { type AxiosPromise } from 'axios';

export const getFaq = (params: any): AxiosPromise => {
  const { $coreApi: coreApi } = useNuxtApp()
  return coreApi.get('/v1/faq', { params: params })
}

export const sendContactForm = (params: any): AxiosPromise => {
  const { $coreApi: coreApi } = useNuxtApp()
  return coreApi.post('/v1/faq/ticket', params)
}